var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoMainDark(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 87,
    height: 21,
    viewBox: "0 0 87 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 84.048,
    height: 21,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Web_1920_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 87,
    height: 21
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web_1920_2",
    "data-name": "Web 1920 \\u2013 2",
    clipPath: "url(#clip-Web_1920_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M1153.03,65.347a.183.183,0,0,1-.038,0h-.275v.416h-.454v-1.81h.832a.7.7,0,0,1,.388,1.3l.4.506h-.544Zm-.313-.367h.257c.272,0,.377-.149.377-.316a.3.3,0,0,0-.334-.323h-.3Z",
    transform: "translate(-1071.121 -59.452)",
    fill: "#002f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M1134.753,51.517a2.146,2.146,0,1,1,2.146-2.146,2.148,2.148,0,0,1-2.146,2.146m0-3.863a1.717,1.717,0,1,0,1.717,1.717,1.719,1.719,0,0,0-1.717-1.717",
    transform: "translate(-1052.85 -43.899)",
    fill: "#002f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M276.951,114.6h-8.4a3.269,3.269,0,0,0,.918,1.435,2.422,2.422,0,0,0,1.718.612,2.7,2.7,0,0,0,1.471-.424,3.646,3.646,0,0,0,1.141-1.177l2.777,2.259a6.124,6.124,0,0,1-2.412,2,7.859,7.859,0,0,1-3.447.729,6.733,6.733,0,0,1-2.671-.518,6.254,6.254,0,0,1-2.082-1.424,6.5,6.5,0,0,1-1.353-2.106,6.871,6.871,0,0,1-.482-2.588,6.964,6.964,0,0,1,.482-2.6,6.476,6.476,0,0,1,1.353-2.118,6.264,6.264,0,0,1,2.082-1.424,6.733,6.733,0,0,1,2.671-.518,6.377,6.377,0,0,1,2.636.518,5.715,5.715,0,0,1,1.965,1.435,6.217,6.217,0,0,1,1.235,2.2,8.845,8.845,0,0,1,.424,2.788Zm-4.165-2.494a3.374,3.374,0,0,0-.071-.659,1.567,1.567,0,0,0-.294-.647,1.647,1.647,0,0,0-.624-.482,2.581,2.581,0,0,0-1.082-.188,1.8,1.8,0,0,0-1.353.576,3.507,3.507,0,0,0-.812,1.4Z",
    transform: "translate(-245.528 -99.226)",
    fill: "#002f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M473.729,106.742a8.689,8.689,0,0,1,2.577.329A3.692,3.692,0,0,1,478,108.13,4.335,4.335,0,0,1,478.93,110a11.673,11.673,0,0,1,.282,2.765V119.8h-4.447v-7.036a2.763,2.763,0,0,0-.4-1.659,1.728,1.728,0,0,0-1.459-.529,2.635,2.635,0,0,0-1.835.682V119.8h-4.447V106.977h4.447v.494a5.442,5.442,0,0,1,2.659-.729",
    transform: "translate(-433.764 -99.225)",
    fill: "#002f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M668.892,34.065a2.4,2.4,0,0,1-.941-.188,2.534,2.534,0,0,1-.788-.518,2.31,2.31,0,0,1-.529-.777,2.447,2.447,0,0,1,0-1.882,2.318,2.318,0,0,1,.529-.777,2.548,2.548,0,0,1,.788-.518,2.425,2.425,0,1,1,.941,4.659m-2.212.847h4.447V47.737H666.68Z",
    transform: "translate(-619.515 -27.161)",
    fill: "#002f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M773.6,110.084v12.824h-4.447v-.494a5.439,5.439,0,0,1-2.659.729,8.687,8.687,0,0,1-2.577-.329,3.683,3.683,0,0,1-1.694-1.059,4.328,4.328,0,0,1-.93-1.871,11.674,11.674,0,0,1-.282-2.765v-7.036h4.447v7.036a2.761,2.761,0,0,0,.4,1.659,1.728,1.728,0,0,0,1.459.529,2.859,2.859,0,0,0,1.012-.176,2.456,2.456,0,0,0,.824-.506v-8.542Z",
    transform: "translate(-707.418 -102.332)",
    fill: "#002f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M963.172,118.8l1.624-3.138q.635.282,1.153.471t1,.318a6.987,6.987,0,0,0,.953.188,8.369,8.369,0,0,0,1.035.059,1.586,1.586,0,0,0,.812-.165.488.488,0,0,0,.271-.425.576.576,0,0,0-.059-.259.525.525,0,0,0-.247-.212,4.069,4.069,0,0,0-.565-.213q-.377-.118-1.035-.26a15.018,15.018,0,0,1-1.894-.554,5.737,5.737,0,0,1-1.494-.8,3.37,3.37,0,0,1-.988-1.191,3.828,3.828,0,0,1-.353-1.722,4.1,4.1,0,0,1,.341-1.687,3.588,3.588,0,0,1,.988-1.309,4.744,4.744,0,0,1,1.565-.849,6.594,6.594,0,0,1,2.094-.307,11.5,11.5,0,0,1,2.918.329,20.28,20.28,0,0,1,2.259.729l-1.483,3.13a16.056,16.056,0,0,0-1.906-.565,8.36,8.36,0,0,0-1.883-.235,1.534,1.534,0,0,0-.788.129.451.451,0,0,0-.177.388.439.439,0,0,0,.094.282.969.969,0,0,0,.34.235,4.191,4.191,0,0,0,.668.235q.422.118,1.079.259a7.873,7.873,0,0,1,3.353,1.412A3.353,3.353,0,0,1,974,115.825a4.1,4.1,0,0,1-.374,1.777,3.717,3.717,0,0,1-1.053,1.329,4.735,4.735,0,0,1-1.638.824,7.463,7.463,0,0,1-2.112.282q-.871,0-1.565-.047a9.361,9.361,0,0,1-1.341-.187,10.609,10.609,0,0,1-1.306-.374,12.015,12.015,0,0,1-1.435-.631",
    transform: "translate(-895.347 -99.225)",
    fill: "#002f4f"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1",
    "data-name": "Line 1",
    y1: 0.001,
    transform: "translate(0.013 1.534)",
    fill: "none",
    stroke: "#53ac82",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M9.111,26.833a3.889,3.889,0,0,0-.2-1.244c-.01-.03-.02-.06-.031-.09l0-.008A3.566,3.566,0,0,0,7.09,23.417a3.874,3.874,0,0,0-1.7-.477,4.943,4.943,0,0,0-.969-.008c-4.43,0-4.411-1.1-4.409-1.134a2.629,2.629,0,0,0,1.912,2.946,3.878,3.878,0,0,0-.608,2.089s-.529-1.8,3.531-1.521,4.263,1.521,4.263,1.521",
    transform: "translate(0 -20.263)",
    fill: "#39a376"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M14.22,2.67a4.939,4.939,0,0,1,.969.008,3.873,3.873,0,0,1,1.7.477,3.627,3.627,0,0,1,.816.567,4.954,4.954,0,0,0-3.148-1.575A4.388,4.388,0,0,1,11.809,0a2.109,2.109,0,0,0,0,1.572,2.157,2.157,0,0,1-1.261-.8,3.973,3.973,0,0,0,.2,1.507,11.328,11.328,0,0,0,3.475.391",
    transform: "translate(-9.796 -0.001)",
    fill: "#002f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M153.168,21.8c0,.038.021,1.134-4.409,1.134a4.939,4.939,0,0,0-.969.008,3.874,3.874,0,0,0-1.7.477,3.567,3.567,0,0,0-1.783,2.074l0,.008c-.01.03-.021.06-.031.09a3.891,3.891,0,0,0-.2,1.244l2.155-1.071s-.653-.563,2.972-.45,2.842,1.506,2.842,1.506a4,4,0,0,0-.783-2.073,2.629,2.629,0,0,0,1.912-2.946",
    transform: "translate(-133.925 -20.263)",
    fill: "#39a376"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M164.623,2.67a4.939,4.939,0,0,0-.969.008,3.873,3.873,0,0,0-1.7.477,3.627,3.627,0,0,0-.816.567,4.954,4.954,0,0,1,3.148-1.575A4.389,4.389,0,0,0,167.034,0a2.109,2.109,0,0,1,0,1.572,2.156,2.156,0,0,0,1.261-.8,3.971,3.971,0,0,1-.2,1.507,11.328,11.328,0,0,1-3.475.391",
    transform: "translate(-149.792 -0.001)",
    fill: "#002f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M49.232,178.089a6.983,6.983,0,0,0,2.519,1.539,9,9,0,0,0,3.5.682,12.365,12.365,0,0,0,2.7-.287,10.753,10.753,0,0,0,2.532-.86,11.44,11.44,0,0,0,2.125-1.337v-6.448H54.8V175.1h3.148v.478a5.051,5.051,0,0,1-1.265.585,4.906,4.906,0,0,1-1.433.2,3.913,3.913,0,0,1-1.659-.358,4.275,4.275,0,0,1-1.361-.991,4.639,4.639,0,0,1-.919-1.492c-.025-.065-.049-.132-.072-.2.038.129.076.259.116.39a5.148,5.148,0,0,0,.316.835,10.745,10.745,0,0,0,3.377,3.851s-4.375.071-6.471-3.039a5.123,5.123,0,0,0,.657,2.723",
    transform: "translate(-45.151 -159.31)",
    fill: "#002f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M116.763,55.553a3.885,3.885,0,0,1,1.188-2.8q-.6-.058-1.236-.058a9.364,9.364,0,0,0-2.021.215c.037.04.073.081.108.122l.012.014c.032.038.064.078.094.117l.019.025c.029.037.056.076.084.114l.024.034q.038.055.074.112l.027.041c.023.036.045.073.066.11l.028.049q.03.053.058.108l.029.056q.026.052.051.106l.028.062c.015.034.03.069.044.1l.027.069c.013.034.026.068.038.1s.017.05.026.076.022.066.032.1.016.055.023.082.018.064.026.1.014.059.021.089.014.062.02.094.012.065.017.1.011.059.015.089.009.072.014.107.007.055.01.082.007.083.009.125c0,.023,0,.045,0,.068q0,.1.005.2c0,.058,0,.116,0,.174,0,.026,0,.052,0,.079s0,.055-.006.082-.006.073-.011.109V56a3.871,3.871,0,0,1-.574,1.628l1.14,1.42,1.122-1.38a3.876,3.876,0,0,1-.627-2.118",
    transform: "translate(-106.618 -48.983)",
    fill: "#002f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M19.98,139.964l-.066.005c-.074,0-.133,0-.209,0-.111,0-.207.009-.315,0-.017,0-.049.008-.066.006l-.046-.005a7.883,7.883,0,0,1-3.3-.629c-.017.052-.034.1-.049.156v0a8.216,8.216,0,0,0-.328,1.964,7.978,7.978,0,0,0,.031,1.253c.008.085.02.169.03.253,0,.026.006.052.01.079a8.02,8.02,0,0,0,.623,2.194,8.57,8.57,0,0,0,1.935,2.746l.344.316a5.124,5.124,0,0,1-.657-2.723c2.1,3.11,6.471,3.039,6.471,3.039a10.747,10.747,0,0,1-3.377-3.851,5.167,5.167,0,0,1-.316-.835c-.04-.131-.078-.261-.116-.39-.014-.048-.028-.1-.042-.142a5.218,5.218,0,0,1-.219-1.527,4.712,4.712,0,0,1,.119-1.062c.043-.167.094-.343.151-.513l.005-.014c.018-.05.037-.1.057-.148v0l0,0c.027-.066.056-.13.086-.194l-.522.018c-.076.01-.156,0-.234,0",
    transform: "translate(-14.488 -129.529)",
    fill: "#39a376"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M21.748,68.933a9.592,9.592,0,0,0-8.407.225l-.917.037-.917-.037A9.592,9.592,0,0,0,3.1,68.933c-.261,3.1.042,3.307.042,3.307a3.653,3.653,0,0,0,1.129.837,7.882,7.882,0,0,0,3.3.629c.326,0,.641,0,.935-.01l.522-.018.179-.007c1.661-.06,1.978-.971,2.1-1.336s.348-.972.348-.972a2.907,2.907,0,0,1,.351-.733.6.6,0,0,1,.417-.272.6.6,0,0,1,.416.271,2.9,2.9,0,0,1,.352.734s.226.608.348.972.439,1.275,2.1,1.336,4.57.241,6.068-1.431c0,0,.3-.2.042-3.307M10.555,72c-.19.467-.217,1.014-1.609,1.081a13.346,13.346,0,0,1-3.234-.091,5.7,5.7,0,0,1-.585-.146,4.53,4.53,0,0,1-1.013-.448,6.06,6.06,0,0,1,.15-3.281,7.5,7.5,0,0,1,6.824.652A22.382,22.382,0,0,1,10.555,72m10.178.4c-1.507.912-3.44.753-4.832.685S14.483,72.464,14.292,72a22.362,22.362,0,0,1-.534-2.233,7.5,7.5,0,0,1,6.824-.652,6.06,6.06,0,0,1,.15,3.281",
    transform: "translate(-2.782 -63.265)",
    fill: "#002f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M51.209,90.969a3.925,3.925,0,0,1,.734-1.334,4.5,4.5,0,0,1,.6,1.267.447.447,0,0,0,.533.2.888.888,0,0,0,.334-.2c.067-.067.133-.2.067-.267-.267-.467-.734-1.467-.8-1.534a.576.576,0,0,0-.4-.2,1.634,1.634,0,0,0-.8.267,2.818,2.818,0,0,0-1.267,1.867c.067.467.934.333,1-.067",
    transform: "translate(-46.673 -82.642)",
    fill: "#00304f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M178.119,90.022a3.925,3.925,0,0,1,.734-1.334,4.5,4.5,0,0,1,.6,1.267.447.447,0,0,0,.534.2.888.888,0,0,0,.333-.2c.067-.067.133-.2.067-.267-.267-.467-.734-1.467-.8-1.534a.576.576,0,0,0-.4-.2,1.634,1.634,0,0,0-.8.267,2.817,2.817,0,0,0-1.267,1.867c.067.4.934.267,1-.067",
    transform: "translate(-164.647 -81.761)",
    fill: "#00304f",
    fillRule: "evenodd"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMainDark);
export default __webpack_public_path__ + "static/media/logo-main-dark.68a2c44003f5b0fa311c8d60c05ce919.svg";
export { ForwardRef as ReactComponent };